import React from 'react';
import { Navigate } from 'react-router';
import { useUser } from '../../context/UserContext';
import ScreenLoader from '../Loader/Loader';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useUser();

  // Show loading while checking authentication
  if (isLoading) {
    return <ScreenLoader />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Render protected content if authenticated
  return children;
};

export default ProtectedRoute;
